import { useMemo } from "react";

import unknownLogo from "@/assets/question-mark.svg";
import vfarmLogo from "@/assets/vfarm.png";
import vstBtcLogo from "@/assets/vstbtc.png";

import { useRates } from "@/lib/hooks/use-rates";
import { useWidget } from "@/lib/hooks/use-widget";
import { Token } from "@/lib/classes/BaseNetwork";
import { MarketData } from "@/lib/context/rates-context";

interface TokenMarketData extends Token {
  image: string;
}

export const useTokenMarketData = (): TokenMarketData[] => {
  const { tokensArray } = useWidget();
  const { marketData } = useRates();

  const getImage = (symbol: string, marketData: MarketData[]) => {
    const matchingMarket = marketData.find(market => symbol === market.id);
    switch (symbol) {
      case "VFARM":
        return vfarmLogo;
      case "vstBTC":
        return vstBtcLogo;
      default:
        break;
    }

    if (!matchingMarket) return unknownLogo;

    return matchingMarket.image;
  };

  return useMemo(() => {
    return tokensArray.map(token => {
      return {
        ...token,
        image: getImage(token?.id || token.symbol, marketData),
      };
    });
  }, [tokensArray, marketData]);
};
